export default function hamburger() {
  const inputs = document.querySelectorAll(".wpcf7-form .wpcf7-form-control");

  inputs.forEach((input) => {
    const labelValue = input.closest(".label")?.querySelector(".label-value");
    if (!labelValue) return;

    function updateLabel() {
      if (input === document.activeElement || input.value.trim() !== "") {
        labelValue.style.opacity = "0.5";
      } else {
        labelValue.style.opacity = "1";
      }
    }

    input.addEventListener("focus", updateLabel);
    input.addEventListener("blur", updateLabel);
    input.addEventListener("input", updateLabel);

    updateLabel();
  });
};